import { Token } from '@frontend/authentication-v2';
import { CostCenterAllowance, CostCenterStatus } from '@frontend/cost-center/types';

import { CostCenterClient } from './cost-center-client';

export const isCostCenterUseEnforced = (value: unknown): boolean => {
    if (typeof value === 'boolean') return value;
    if (typeof value === 'number') return value === 1;
    if (typeof value !== 'string') return false;

    return ['true', '1', 'yes'].includes(value.toLowerCase());
};

export const fetchUserCostCenterAllowance = async (settingValue: unknown, withCredentials?: Token): Promise<CostCenterAllowance> => {
    if (!isCostCenterUseEnforced(settingValue) || !withCredentials) {
        return { use: false, cost_centers: [] };
    }

    const response = await CostCenterClient.fetchCostCenters({ status: CostCenterStatus.ACTIVE }, withCredentials);
    return { use: true, cost_centers: response.results };
};
